import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import { Pagination, Autoplay } from 'swiper';

export default function AutoSwiper({ swiperArr = [] }: any) {
    return (
        <div className={`auto-swiper`}>
            <Swiper
                className={`swiper-box ${swiperArr?.length > 1 ? '' : 'single'}`}
                modules={[Pagination, Autoplay]}
                spaceBetween={0}
                loop={swiperArr?.length > 1}
                slidesPerView={'auto'}
                initialSlide={0}
                pagination={swiperArr?.length > 1 ? { clickable: true } : false}
                autoplay={
                    swiperArr?.length > 1
                        ? {
                              delay: 4000,
                              disableOnInteraction: false,
                              pauseOnMouseEnter: true,
                          }
                        : false
                }
            >
                {swiperArr?.map((item: any, k: number) => (
                    <SwiperSlide className={`swiper-item ${k === 0 ? 'first' : ''}`} key={k}>
                        {String(item).endsWith('.mp4') || String(item).endsWith('.webm') ? (
                            <video src={item} muted autoPlay loop playsInline preload="auto" width="100%" height="100%" aria-label={'swiper video'} />
                        ) : (
                            <EFPicture
                                src={`${item?.img}`}
                                srcPad={`${item?.imgPad || item?.img}`}
                                srcMobile={`${item?.imgMobile || item?.imgPad || item?.img}`}
                                alt={'swiper image'}
                            />
                        )}
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
